import { Stack, Step, StepLabel, Stepper } from '@mui/material';
import React from 'react';
import { useCreateInvoiceContext } from '../../create-invoice-page-contexts/create-invoice-context/create-invoice-context';
import { INVOICE_CREATION_STEPS } from '../../create-invoice-page-contexts/create-invoice-context/create-invoice-context-types/invoice-creation-step';

export const CreateInvoiceStepper: React.FC = () => {
  const {
    invoiceCreationStepper: { currentStep, goToStep },
  } = useCreateInvoiceContext();

  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        padding: '24px 0px 16px 0px',
        margin: 'auto',
        maxWidth: '340px',
      })}
    >
      <Stepper activeStep={currentStep}>
        <Step
          className="hover:cursor-pointer"
          onClick={() => goToStep(INVOICE_CREATION_STEPS.settings)}
          sx={{
            '& .MuiStepLabel-root .Mui-completed': {
              color: 'success.main',
            },
            '& .MuiStepLabel-label.Mui-completed': {
              color: 'black',
            },
            '& .MuiStepLabel-root .Mui-active': {
              color: '#0D1B27DE',
            },
          }}
        >
          <StepLabel>Invoice details</StepLabel>
        </Step>

        <Step>
          <StepLabel>Pricing options</StepLabel>
        </Step>
      </Stepper>
    </Stack>
  );
};
